import React, { useEffect, useState } from 'react'
import { Button, LogoLoader, showToast } from '../../../../components'
import { profileMerge, profileOverrite } from '../../../../redux/slices/recruitmentSourcing/SourcingApi';
import { useDispatch, useSelector } from 'react-redux';
import { updateCareerBuilderApplicantsDataStart, updateMonsterApplicantsDataStart } from '../../../../redux/slices/internalDbES/internalDbESlice';

function base64ToUint8Array(base64) {
  const raw = atob(base64);
  const uint8Array = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
      uint8Array[i] = raw.charCodeAt(i);
  }
  return uint8Array;
}

const ProfileMigrationModel = ({onCancel, candidate, data, source}) => {
  const [operation, setOperation] = useState();
  const [profileDetails, setProfileDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const { careerBuilder } = useSelector((state) => state.internalDbES);
  const { tableResponse: cbTableResponse, fullResponse: cbFullResponse, existingCandidates: cbExistingCandidates } = careerBuilder;

  const { monster } = useSelector((state) => state.internalDbES);
  const { tableResponse: mTableResponse, fullResponse: mFullResponse, existingCandidates: mExistingCandidates } = monster;

  const dispatch = useDispatch();

  const onSubmit = async () => {
    if (!operation) {
      showToast("Please select one option", "error");
      return
    }
    const formData = new FormData();
    formData.append("coll", "Candidate");
    let uiid;

    switch (source) {
      case 2: { //Career Builder
        formData.append("payload",  JSON.stringify([
          {
              type: "PUSH",
              value: { resumeIds: {id: data?.resumeId} }
          }
        ]));
        const resumeData = data.resume;
        const uint8Array = new Uint8Array(resumeData.buffer.data);
        const blob = new Blob([uint8Array], { type: resumeData.mimetype });
        const file = new File([blob], resumeData.originalname, { type: resumeData.mimetype });

        formData.append("doc", file);
        uiid = data?.existingApplicant.uiid

        break;
      }
      case 3: { //Monster
        formData.append("payload",  JSON.stringify([
          {
              type: "PUSH",
              value: { resumeIds: data?.new?.resumeIds?.[0] }
          }
        ]));
        
        const fileObj = data?.new?.file;
        const uint8Array = base64ToUint8Array(fileObj.file);
        const blob = new Blob([uint8Array], { type: fileObj.fileContentType });
        const file = new File([blob], fileObj.fileName, {
            type: fileObj.fileContentType,
        });

        formData.append("doc", file);
        uiid = data?.old?.uiid

        break;
      }
    }   

    let response;
    if (operation === "overwrite") {
      setLoading(true);
      const preActions = JSON.stringify(["MergeOrOverride"]);
      formData.append("preActions", preActions);
      response = await profileOverrite({coll: "Candidate", uiid}, formData);
      if (response?.success) {
        showToast("Profile Migration Success", "success");
        setLoading(false);
        // onCancel()
      } else {
        showToast("Internal Server Error", "error");
        setLoading(false);
      }
    } else if (operation === "merge") {
      setLoading(true);
      const postActions = JSON.stringify(["addDoc"]);
      formData.append("postActions", postActions);
      response = await profileMerge({coll: "Candidate", uiid}, formData);
      if (response?.success) {
        showToast("Profile Migration Success", "success");
        setLoading(false);
        // onCancel()
      } else {
        showToast("Internal Server Error", "error");
        setLoading(false);
      }
    }

    switch (source) {
      case 2: {
        if (response?.success) {
          dispatch(updateCareerBuilderApplicantsDataStart({ existing: candidate, newCandidate: response?.data?.data, 
            tableResponse: cbTableResponse, fullResponse: cbFullResponse, existingCandidates: cbExistingCandidates }))
          onCancel()
        } else {
          onCancel()
        }
        break;        
      }
      case 3: {
        if (response?.success) {
          dispatch(updateMonsterApplicantsDataStart({ existing: candidate, newCandidate: response?.data?.data, tableResponse: mTableResponse, 
          fullResponse: mFullResponse, existingCandidates: mExistingCandidates }))
         onCancel()
        } else {
          onCancel()
        }
        break;  
      }
    }
    
  }

  useEffect(() => {;
    let profile;
    switch (source) {
      case 2: {
        profile = {
          uiid: data?.existingApplicant?.uiid,
          email: data?.newApplicant?.email?.primary?.email ?? "",
          name: data?.existingApplicant?.firstName + " " + data?.existingApplicant?.lastName
        };
        break;
      }
      case 3: {
        profile = {
          uiid: data?.old?.uiid,
          email: data?.old?.email?.primary?.email ?? "",
          name: data?.old?.firstName + " " + data?.old?.lastName
        }
        break;
      }
    }
    setProfileDetails(profile);
  }, [data]);

  return loading ? 
            <div className='min-h-[350px] flex justify-center items-center'>
              <LogoLoader />
            </div> : (
    <div className='flex flex-col'>
      <span className='text-neutral-400'>We found an existing profile with same email or mobile number</span>
      <div className='flex items-center bg-gray-50 p-3 gap-3 rounded-lg my-3'>
        <Button
          type='icon'
          icon="person"
          variant='text'
          className='bg-primary-50'
          size='lg'
        />
        <div className='flex flex-col'>
          <span>{profileDetails?.uiid} - {profileDetails?.name}</span>
          <span>{profileDetails?.email || "-"}</span>
        </div>
      </div>

      <span className='font-medium'>What would you like to do ?</span>

      <div className='grid grid-cols-2 gap-3 my-2'>
        <div className={`flex flex-col border-2 ${operation === "overwrite" ? 'border-primary-300' : 'border-gray-100'} rounded-md p-3 cursor-pointer`}
          onClick={() => setOperation("overwrite")}
        >
          <div className='flex items-center gap-3 mb-2'>
            <Button
              type='icon'
              icon="cycle"
              variant='text'
              className='bg-primary-50'
              size='lg'
            />
            <span>Overwrite Existing</span>
          </div>
          <p className='text-sm'>This option will replace the existing resume with the new resume. The previous data will be permanently lost.</p>
        </div>

        <div className={`flex flex-col border-2 ${operation === "merge" ? 'border-primary-300' : 'border-gray-100'} rounded-md p-3 cursor-pointer`}
          onClick={() => setOperation("merge")}
        >
          <div className='flex items-center gap-3 mb-2'>
            <Button
              type='icon'
              icon="call_merge"
              variant='text'
              className='bg-primary-50'
              size='lg'
            />
            <span>Merge Profile</span>
          </div>
          <p className='text-sm'>This will automatically combine the existing profile with the new resume data, preventing all information.</p>
        </div>
      </div>

      <div className='flex justify-end gap-3 my-5'>
        <Button
          title={"Cancel"}
          variant='outlined'
          onClick={() => onCancel()}
        />
        <Button
          title={"Confirm Selection"}
          onClick={() => onSubmit()}
        />
      </div>
    </div>
  )
}

export default ProfileMigrationModel